import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import { createRoot } from 'react-dom/client'
import { App } from './modules/app/app.component'
import { initReactGA } from './modules/app/app.functions'
import './style/index.scss'

const root = createRoot(document.getElementById('root') as HTMLDivElement)
initReactGA()

root.render(<App />)
